<template>
  <div class="tiempos-page">
    <!-- Header -->
    <div class="tm-header">
      <div>
        <span class="header-eyebrow">Produccion</span>
        <h2 class="header-title">Tiempos de fabricacion</h2>
      </div>
      <div class="header-actions">
        <button class="btn-tm btn-tm--ghost" @click="imgTable = !imgTable">
          <i :class="imgTable ? 'fa-solid fa-camera' : 'fa-solid fa-camera-slash'"></i>
        </button>
        <button class="btn-tm btn-tm--ghost" @click="openModalPrecios()">
          <i class="fa-solid fa-euro-sign"></i> Precios/h
        </button>
      </div>
    </div>

    <!-- Precios KPIs -->
    <div class="kpi-strip">
      <div class="kpi-card" v-for="item in statisticsItems" :key="item.subtitle">
        <span class="kpi-label">{{ item.subtitle }}</span>
        <span class="kpi-value">{{ item.title }} <span class="kpi-unit">€/h</span></span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Seleccionados</span>
        <span class="kpi-value" :class="selectedSku.length > 0 ? 'kpi-value--accent' : ''">{{ selectedSku.length }}</span>
        <span class="kpi-foot">SKUs</span>
      </div>
    </div>

    <!-- Table -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado SKU</h3>
        <div class="list-card__filters">
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input type="text" class="search-box__input" placeholder="Buscar SKU..." v-model="buscar" />
          </div>
        </div>
      </div>

      <!-- Action bar -->
      <div class="action-bar" v-if="selectedSku.length > 0">
        <span class="action-bar__count">{{ selectedSku.length }} seleccionados</span>
        <div class="action-bar__buttons">
          <button class="btn-tm btn-tm--primary btn-tm--sm" @click="openTimesSku()">
            <i class="fa-solid fa-clock"></i> Editar tiempos
          </button>
          <button class="btn-tm btn-tm--ghost btn-tm--sm" @click="openPackagingSku()">
            <i class="fa-solid fa-box"></i> Packaging
          </button>
          <button class="btn-tm btn-tm--ghost btn-tm--sm" @click="openShippingSku()">
            <i class="fa-solid fa-truck"></i> Shipping
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="articulosBusqueda"
          :fields="columnasTable"
          class="mb-0"
          hover
          sort-icon-left
          selectable
          responsive
          @row-selected="onRowSelected"
          select-mode="range"
          show-empty
          empty-text="No se encontraron SKUs"
          thead-class="table-head"
          tbody-tr-class="table-row-sel"
        >
          <template #cell(img)="data">
            <img v-if="data.item.image" :src="data.item.image" class="cell-img" />
            <div v-else class="cell-img-empty"><i class="fa-solid fa-image"></i></div>
          </template>

          <template #cell(sku)="data">
            <span class="cell-sku">{{ data.item.sku }}</span>
          </template>

          <template #cell(corte)="data">
            <span class="cell-time" v-if="data.item.corte">{{ data.item.corte }}'</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(preparado)="data">
            <span class="cell-time" v-if="data.item.preparado">{{ data.item.preparado }}'</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(confeccion)="data">
            <span class="cell-time" v-if="data.item.confeccion">{{ data.item.confeccion }}'</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(packaging)="data">
            <span class="cell-price" v-if="data.item.packaging">{{ data.item.packaging }}€</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(shipping)="data">
            <span class="cell-price" v-if="data.item.shipping">{{ data.item.shipping }}€</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(precioTotalUbrique)="data">
            <span class="cell-price" v-if="data.item.precioTotalUbrique">{{ data.item.precioTotalUbrique }}€</span>
            <span class="cell-muted" v-else>--</span>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ articulosBusqueda.length }} SKUs</span>
      </div>
    </div>

    <!-- Modal: Editar tiempos -->
    <b-modal
      ref="modal-times-sku"
      modal-class="modal-tm"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon modal-hdr__icon--primary">
            <i class="fa-solid fa-clock"></i>
          </div>
          <h4 class="modal-hdr__title">Editar tiempos</h4>
          <p class="modal-hdr__sub">{{ skuSelectTitle }}</p>
        </div>

        <div class="modal-body-custom">
          <div v-if="localizacionSku == 0" class="field-row field-row--3">
            <div class="field">
              <label class="field__label">Corte</label>
              <input ref="inputCorteForm" v-model="inputCorte" placeholder="min" class="field__input field__input--mono" />
            </div>
            <div class="field">
              <label class="field__label">Preparado</label>
              <input v-model="inputPreparado" placeholder="min" class="field__input field__input--mono" />
            </div>
            <div class="field">
              <label class="field__label">Confeccion</label>
              <input v-model="inputConfeccion" placeholder="min" class="field__input field__input--mono" />
            </div>
          </div>
          <div v-else class="field">
            <label class="field__label">Precio total Ubrique</label>
            <input v-model="inputTotalPrecioUbrique" placeholder="0.00" class="field__input field__input--mono" v-on:keyup.enter="guardarTiempos()" />
          </div>

          <div class="field-row field-row--2" style="margin-top: 14px;">
            <div class="field">
              <label class="field__label">Packaging</label>
              <input v-model="inputPackaging" placeholder="0.00" class="field__input field__input--mono" v-on:keyup.enter="guardarTiempos()" />
            </div>
            <div class="field">
              <label class="field__label">Shipping</label>
              <input v-model="inputShipping" placeholder="0.00" class="field__input field__input--mono" v-on:keyup.enter="guardarTiempos()" />
            </div>
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-times-sku'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="guardarTiempos()">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Precios -->
    <b-modal
      ref="modal-times-precios"
      modal-class="modal-tm"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon modal-hdr__icon--warning">
            <i class="fa-solid fa-euro-sign"></i>
          </div>
          <h4 class="modal-hdr__title">Precios por hora</h4>
          <p class="modal-hdr__sub">Coste de cada fase de produccion</p>
        </div>

        <div class="modal-body-custom">
          <div class="precios-list">
            <div class="precio-item" v-for="item in statisticsItems" :key="'p-'+item.subtitle">
              <span class="precio-item__label">{{ item.subtitle }}</span>
              <div class="precio-item__input-wrap">
                <input v-model="item.title" class="precio-item__input" placeholder="0" />
                <span class="precio-item__unit">€/h</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-times-precios'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="guardarPrecios()">
            <i class="fa-solid fa-floppy-disk"></i> Guardar precios
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Packaging -->
    <b-modal
      ref="modal-packaging-sku"
      modal-class="modal-tm"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon modal-hdr__icon--primary">
            <i class="fa-solid fa-box"></i>
          </div>
          <h4 class="modal-hdr__title">Packaging</h4>
          <p class="modal-hdr__sub">{{ skuSelectTitle }}</p>
        </div>

        <div class="modal-body-custom">
          <div class="field">
            <label class="field__label">Precio packaging</label>
            <input ref="inputPackagingForm" v-model="inputPackaging" placeholder="0.00" class="field__input field__input--mono field__input--center" v-on:keyup.enter="guardarPackaging()" />
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-packaging-sku'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="guardarPackaging()">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Shipping -->
    <b-modal
      ref="modal-shipping-sku"
      modal-class="modal-tm"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon modal-hdr__icon--primary">
            <i class="fa-solid fa-truck"></i>
          </div>
          <h4 class="modal-hdr__title">Shipping</h4>
          <p class="modal-hdr__sub">{{ skuSelectTitle }}</p>
        </div>

        <div class="modal-body-custom">
          <div class="field">
            <label class="field__label">Precio shipping</label>
            <input ref="inputShippingForm" v-model="inputShipping" placeholder="0.00" class="field__input field__input--mono field__input--center" v-on:keyup.enter="guardarShipping()" />
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-shipping-sku'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="guardarShipping()">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  data(){
    return{
      buscar: "",
      statisticsItems: [
        { icon: 'fa-solid fa-scissors', color: 'light-warning', title: 0, subtitle: 'Corte', id: -1 },
        { icon: 'fa-solid fa-hands-praying', color: 'light-primary', title: 0, subtitle: 'Preparado', id: -1 },
        { icon: 'fa-solid fa-timeline', color: 'light-info', title: 0, subtitle: 'Confeccion', id: -1 },
      ],
      columnasTable: [
        { key: "sku", label: "SKU", sortable: true },
        { key: "corte", label: "Corte", sortable: true },
        { key: "preparado", label: "Preparado", sortable: true },
        { key: "confeccion", label: "Confeccion", sortable: true },
        { key: "packaging", label: "Packaging", sortable: true },
        { key: "shipping", label: "Shipping", sortable: true },
        { key: "precioTotalUbrique", label: "Ubrique", sortable: true },
      ],
      articulos: [],
      articulosBusqueda: [],
      imgTable: false,
      skuSelectTitle: "",
      skuSelect: {corte: "", preparado: "", confeccion: "", packaging: "", shipping: "", totalTiempo: ""},
      inputCorte: "",
      inputPreparado: "",
      inputConfeccion: "",
      inputPackaging: "",
      inputShipping: "",
      inputTotalPrecioUbrique: "",
      localizacionSku: 0,
      selectedSku:[],
    }
  },
  methods:{
    load(){
      axios.post("/uso", {seccion:"skuTiempos"});
      axios.get("/tiempos/variants").then(r => r.data).then(res => {
        this.articulos = res;
        this.articulosBusqueda = this.articulos;
      });
      axios.get("/tiempos/precios").then(r => r.data).then(resPrecios => {
        resPrecios.forEach(pr => {
          let index = this.statisticsItems.findIndex(x => x.subtitle.toLowerCase() === pr.trabajo.toLowerCase());
          if (index > -1) {
            this.statisticsItems[index].id = pr.id;
            this.statisticsItems[index].title = pr.precio;
          }
        });
      });
    },
    buscarFuncion(){
      this.articulosBusqueda = [];
      this.articulos.forEach(mat => {
        if(mat.sku.toLowerCase().includes(this.buscar.toLowerCase()))
          this.articulosBusqueda.push(mat);
      });
    },
    onRowSelected(items) {
      this.selectedSku = items;
    },
    openTimesSku(){
      if(this.selectedSku.length > 0) {
        this.skuSelectTitle = this.selectedSku.length == 1 ? this.selectedSku[0].sku : "Multiple SKU (" + this.selectedSku.length + ")";
        let dataInfo = JSON.parse(JSON.stringify(this.selectedSku[0]));
        this.inputCorte = dataInfo.corte;
        this.inputPreparado = dataInfo.preparado;
        this.inputConfeccion = dataInfo.confeccion;
        this.inputPackaging = dataInfo.packaging;
        this.inputShipping = dataInfo.shipping;
        this.inputTotalPrecioUbrique = dataInfo.precioTotalUbrique;
        this.localizacionSku = this.selectedSku[0].localizacion;
        this.$refs['modal-times-sku'].show();
        setTimeout(()=>{this.$refs.inputCorteForm.focus(); }, 300);
      }
    },
    openPackagingSku(){
      if(this.selectedSku.length > 0) {
        this.skuSelectTitle = this.selectedSku.length == 1 ? this.selectedSku[0].sku : "Multiple SKU (" + this.selectedSku.length + ")";
        let dataInfo = JSON.parse(JSON.stringify(this.selectedSku[0]));
        this.inputPackaging = dataInfo.packaging;
        this.$refs['modal-packaging-sku'].show();
        setTimeout(()=>{this.$refs.inputPackagingForm.focus(); }, 300);
      }
    },
    openShippingSku(){
      if(this.selectedSku.length > 0) {
        this.skuSelectTitle = this.selectedSku.length == 1 ? this.selectedSku[0].sku : "Multiple SKU (" + this.selectedSku.length + ")";
        let dataInfo = JSON.parse(JSON.stringify(this.selectedSku[0]));
        this.inputShipping = dataInfo.shipping;
        this.$refs['modal-shipping-sku'].show();
        setTimeout(()=>{this.$refs.inputShippingForm.focus(); }, 300);
      }
    },
    guardarTiempos(){
      this.selectedSku.forEach(element => {
        let infoTime = {
          id: element.idTiempo, sku: element.sku,
          corte: this.inputCorte, preparado: this.inputPreparado,
          confeccion: this.inputConfeccion, packaging: this.inputPackaging,
          shipping: this.inputShipping, precioTotal: this.inputTotalPrecioUbrique, totalTiempo: ""
        }
        if(infoTime.id == -1)
          axios.post("/tiempos/new", infoTime).then(r => r.data).then(res => { element.idTiempo = res.insertId; });
        else
          axios.post("/tiempos/update", infoTime);

        element.corte = this.inputCorte;
        element.preparado = this.inputPreparado;
        element.confeccion = this.inputConfeccion;
        element.packaging = this.inputPackaging;
        element.shipping = this.inputShipping;
        element.precioTotalUbrique = this.inputTotalPrecioUbrique;
      });
      this.$refs['modal-times-sku'].hide();
    },
    guardarPackaging(){
      this.selectedSku.forEach(element => {
        let infoTime = { id: element.idTiempo, sku: element.sku, packaging: this.inputPackaging }
        if(infoTime.id == -1)
          axios.post("/tiempos/packaging/new", infoTime).then(r => r.data).then(res => { element.idTiempo = res.insertId; });
        else
          axios.post("/tiempos/packaging/update", infoTime);
        element.packaging = this.inputPackaging;
      });
      this.$refs['modal-packaging-sku'].hide();
    },
    guardarShipping(){
      this.selectedSku.forEach(element => {
        let infoTime = { id: element.idTiempo, sku: element.sku, shipping: this.inputShipping }
        if(infoTime.id == -1)
          axios.post("/tiempos/shipping/new", infoTime).then(r => r.data).then(res => { element.idTiempo = res.insertId; });
        else
          axios.post("/tiempos/shipping/update", infoTime);
        element.shipping = this.inputShipping;
      });
      this.$refs['modal-shipping-sku'].hide();
    },
    openModalPrecios(){
      this.$refs['modal-times-precios'].show();
    },
    guardarPrecios(){
      this.statisticsItems.forEach(pr => {
        axios.post("/tiempos/precios", { id: pr.id, trabajo: pr.subtitle, precio: pr.title });
      });
      this.$refs['modal-times-precios'].hide();
    }
  },
  watch: {
    buscar(){ this.buscarFuncion(); },
    imgTable(){
      if(this.imgTable)
        this.columnasTable.unshift({ key: "img", label: "Img", sortable: false, thStyle: { width: "70px" } });
      else
        this.columnasTable.shift();
    },
  },
  mounted() { this.load(); }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.tiempos-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
}

// Header
.tm-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

.header-actions { display: flex; gap: 8px; }

// Buttons
.btn-tm {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: $radius-sm;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &--primary { background: $primary; color: white; &:hover { background: $primary-dark; } }
  &--ghost { background: transparent; color: $text-muted; border: 1px solid $border; &:hover { background: $bg; color: $text; } }
  &--sm { padding: 6px 14px; font-size: 12px; }
}

// KPI Strip
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
  color: $text;
  font-feature-settings: "tnum";
  margin: 4px 0 2px;

  &--accent { color: $primary; }
}

.kpi-unit {
  font-size: 12px;
  font-weight: 500;
  color: $text-muted;
}

.kpi-foot {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: $text-muted;
}

// List Card
.list-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 22px;
    border-bottom: 1px solid $border;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0;
  }

  &__footer {
    padding: 12px 22px;
    border-top: 1px solid $border;
  }
}

// Action bar
.action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 22px;
  background: rgba($primary, 0.04);
  border-bottom: 1px solid rgba($primary, 0.1);

  &__count {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: $primary;
  }

  &__buttons { display: flex; gap: 6px; }
}

// Search
.search-box {
  position: relative;
  width: 240px;

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: $text-muted;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

// Table
.table-wrapper { padding: 0; }

// Los ::v-deep van bajo .tiempos-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.tiempos-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 10px 14px;
  background: transparent;
}

.tiempos-page ::v-deep .table-row-sel td {
  padding: 10px 14px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
  cursor: pointer;
}

.tiempos-page ::v-deep .table-row-sel:hover td { background: $bg; }
.tiempos-page ::v-deep .table-row-sel.b-table-row-selected td { background: rgba($primary, 0.06) !important; }

.cell-img {
  width: 50px;
  height: 36px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid $border;
}

.cell-img-empty {
  width: 50px;
  height: 36px;
  border-radius: 5px;
  border: 1px dashed $border;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CBD5E1;
  font-size: 13px;
}

.cell-sku {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 500;
  color: $text;
}

.cell-time {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  color: $primary;
  font-feature-settings: "tnum";
}

.cell-price {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  color: $success;
  font-feature-settings: "tnum";
}

.cell-muted { color: #CBD5E1; font-size: 12px; }

.footer-count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
}

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .tm-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .action-bar { flex-direction: column; gap: 8px; align-items: flex-start; }
  .search-box { width: 100%; }
}
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Modal
.modal-tm {
  .modal-content {
    border-radius: 16px;
    border: 1px solid #E2E8F0;
    box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06);
    overflow: hidden;
  }
  .modal-body { padding: 0; }
}

.modal-inner { padding: 0; }

.modal-hdr {
  text-align: center;
  padding: 28px 28px 0;

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    font-size: 18px;

    &--primary { background: rgba(#3B82F6, 0.1); color: #3B82F6; }
    &--warning { background: rgba(#F59E0B, 0.1); color: #F59E0B; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1E293B;
    margin: 0 0 4px;
  }

  &__sub {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #64748B;
    margin: 0;
  }
}

.modal-body-custom { padding: 22px 28px; }

.modal-ftr {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 28px 24px;
}

// Fields
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #64748B;
    margin: 0;
  }

  &__input {
    border-radius: 8px;
    border: 1px solid #E2E8F0;
    padding: 8px 12px;
    font-size: 14px;
    color: #1E293B;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    width: 100%;

    &:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1); }
    &--mono { font-family: 'JetBrains Mono', monospace; font-feature-settings: "tnum"; }
    &--center { text-align: center; font-size: 20px; font-weight: 700; }
    &::placeholder { color: #CBD5E1; }
  }
}

.field-row {
  display: grid;
  gap: 12px;

  &--2 { grid-template-columns: 1fr 1fr; }
  &--3 { grid-template-columns: 1fr 1fr 1fr; }
}

// Precios list
.precios-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.precio-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #1E293B;
  }

  &__input-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__input {
    width: 70px;
    text-align: center;
    padding: 5px 8px;
    border: 1px solid #E2E8F0;
    border-radius: 6px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 600;
    color: #1E293B;
    font-feature-settings: "tnum";

    &:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1); }
  }

  &__unit {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: #94A3B8;
  }
}

// Modal buttons
.btn-modal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &--primary { background: #3B82F6; color: white; &:hover { background: #2563EB; } }
  &--ghost { background: transparent; color: #64748B; &:hover { background: #F1F5F9; color: #1E293B; } }
}

// Dark mode
.dark-layout {
  .tiempos-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .action-bar { background: rgba(#3B82F6, 0.06); border-color: rgba(#3B82F6, 0.1); }

    .search-box__input { border-color: #334155; color: #E2E8F0; &::placeholder { color: #475569; } &:focus { border-color: #3B82F6; } }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row-sel td { border-color: #334155; }
    .table-row-sel:hover td { background: rgba(255,255,255,0.03); }
    .table-row-sel.b-table-row-selected td { background: rgba(#3B82F6, 0.08) !important; }

    .cell-sku { color: #E2E8F0; }
    .cell-img { border-color: #334155; }
    .cell-img-empty { border-color: #334155; color: #475569; }

    .btn-tm--ghost { border-color: #475569; color: #94A3B8; &:hover { background: #334155; color: #E2E8F0; } }
  }

  .modal-tm .modal-content { background: #1E293B; border-color: #334155; }
  .modal-hdr__title { color: #E2E8F0; }
  .field__label { color: #94A3B8; }
  .field__input { background: #0F172A; border-color: #334155; color: #E2E8F0; &:focus { border-color: #3B82F6; } }
  .precio-item { background: #0F172A; border-color: #334155; }
  .precio-item__label { color: #E2E8F0; }
  .precio-item__input { background: #1E293B; border-color: #334155; color: #E2E8F0; }
  .btn-modal--ghost { color: #94A3B8; &:hover { background: rgba(255,255,255,0.05); color: #E2E8F0; } }
}
</style>
